import setAsset from '../base-saving-actions/set-asset';
import assetTypes from '../../constants/asset-types';

const createAssets = (assetsToCreate) =>
  assetsToCreate.map(({ source, content }) =>
    setAsset(source, { content, assetType: assetTypes.PUBLISHABLE })
  );

export default createAssets;
